require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/es7.symbol.observable.js
// module id = 282
// module chunks = 21